import { api as http } from "@/api";

const unwrap = (p) => p.then((r) => r.data);
const get = (path, params) => unwrap(http.get(`/conf${path}`, params ? { params } : undefined));
const post = (path, body) => unwrap(http.post(`/conf${path}`, body));
const del = (path) => unwrap(http.delete(`/conf${path}`));

export const api = {
  parties: () => get("/parties"),
  createParty: (d) => post("/parties", d),
  deleteParty: (id) => del(`/parties/${id}`),

  orderRows: () => get("/order-rows"),
  saveOrderRows: (rows) => post("/order-rows/bulk", { rows }),
  replaceOrderRows: (rows) => post("/order-rows/replace", { rows }),
  deleteOrderRow: (id) => del(`/order-rows/${id}`),
  autoStatus: () => post("/order-rows/auto-status"),

  stockRows: () => get("/stock-rows"),
  saveStockRows: (rows) => post("/stock-rows/bulk", { rows }),
  replaceStockRows: (rows) => post("/stock-rows/replace", { rows }),
  deleteStockRow: (id) => del(`/stock-rows/${id}`),

  lookups: () => get("/lookups"),
  balanceStock: () => get("/balance-stock"),
  extraStock: () => get("/extra-stock"),
  orderSummary: () => get("/order-summary"),
  companyOrder: (pendingOnly = false) => get("/company-order", { pending_only: pendingOnly }),

  lineRows: (sheet) => get(`/line-sheet/${sheet}`),
  saveLineRows: (sheet, rows) => post(`/line-sheet/${sheet}/bulk`, { rows }),
  replaceLineRows: (sheet, rows) => post(`/line-sheet/${sheet}/replace`, { rows }),
  deleteLineRow: (sheet, id) => del(`/line-sheet/${sheet}/${id}`),
  companyBalance: () => get("/company-balance"),
  wholesaleBalance: () => get("/wholesale-balance"),
  balanceOrder: () => get("/balance-order"),
  stats: () => get("/stats/dashboard"),
  overview: (params = {}) => get("/stats/overview", params),
};

export const errMsg = (e) =>
  e?.response?.data?.detail ? String(e.response.data.detail) : e?.message || "Something went wrong";

export const money = (v) => `₹${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const STATUS_META = {
  not_ready: { label: "Not ready", color: "#ffffff", bg: "#ffffff" },
  arrived: { label: "Arrived", color: "#f6a03d", bg: "#fff6e5" },
  ready: { label: "In stock ready", color: "#b7e4c1", bg: "#eaf6ef" },
};
